<template>
    <div class="d-flex flex-1 h-100 overflow-auto">
        <v-card class="report-container w-100  p-0" style="border-radius: 12px; margin-bottom: 24px">
            <v-toolbar class="shadow-none"  v-if="!fromOrganaize" style="flex: unset;" content-class="h-auto">
                <div class="custom-icon-wrapper">
                    <v-icon @click=" backToAdminPage()">custom-icon left-arrow-icon</v-icon>
                </div>
                <v-toolbar-title class="size-16 dark-text">{{ $t("res_Title_ManageEntityRecipients") }}</v-toolbar-title>
            </v-toolbar>

            <div class="border-top p-4 flex-1 overflow-auto">
                <div class="row align-items-start flex-nowrap m-0 gap-2" style="flex: unset">
                    <div class="col-md-4 p-0 h-100">
                            <v-label>{{ $t("res_Label_EntityRecipient") }} *</v-label>
                            <StructureUserSelector :showInternalUsers="false" :showExternalUsers="false"
                                :showInternalStructures="true"
                                :showExternalStructures="false" :excludeSelf="false"
                                :isMultiple="false" :selectedStructureUser="structureModel"
                                :disabled="fromOrganaize"
                                :disableOtherInternalEntitiesAsExternal="true"
                                :structure_id = "structure_id" :hideStructureWithDisableTransfer="!ShowStructuresInTransferForm"
				                :loadOnlyInScopeInternalStrucutres="ShowStructuresInTransferForm"
                                @structureUserSelectChanged="structureUserSelectChanged" :addressBook_header="$t('res_Label_SelectStructure')"
				                :ignoreHideInTransfer="false">
                            </StructureUserSelector>
                    </div>
                    <div class="col-md-4 p-0 h-100">
                        <div class="d-flex gap-2 h-100 align-items-end">
                            <v-btn color="primary" @click="addRecipientEntity()">{{ structure == null ? $t("res_ButtonText_Add") : $t("res_ButtonText_Edit")}}</v-btn>
                            <v-btn v-if="structure != null" color="primary" @click="deleteRecipientEntity()">{{ $t("res_ButtonText_Delete")}}</v-btn>
                        </div>
                    </div> 
                </div>
            </div>
        </v-card>
    </div>
</template>

<script>
import axios from 'axios';
import router from '@/router/index.js'
import constants from '@/assets/js/constants'
import MultiSelect from 'vue-multiselect'
import ManageStructures from '@/components/ManageStructures.vue';
import ManageApplicationRoles from '@/components/ManageApplicationRoles.vue';
import Pagination from '@/components/Pagination.vue'
import * as utils from '@/assets/js/common.js'
import StructureUserSelector from '@/components/StructureUserSelector.vue'
import UserSignatureManager from '@/components/UserSignatureManager.vue'
import ActionSecurityRole from '@/components/ActionSecurityRole.vue'

export default {
    name: 'ManageEntityRecipients',
    components: { MultiSelect, ManageStructures, ManageApplicationRoles, Pagination, StructureUserSelector,UserSignatureManager,ActionSecurityRole  },
    data: function () {
        return {
            companyId: null,
            client_version_Id: constants.client_version_Id,
            applicationId: 1,
            structure: null,
            structureModel: null,
            structureId: 0,
            ShowStructuresInTransferForm: window.ShowStructuresInTransferForm
        }
    },
    props: {
        structure_id: {type:Number, default:0},
        fromOrganaize :{type : Boolean , default:false},
        // structureProps :{type: Object , default: {}}
    },
    methods: {
        structureUserSelectChanged(item){
            this.structureModel = item;
        },
        backToAdminPage(){
            router.push({ name: 'admin' });
        },
        deleteRecipientEntity(){
            if(this.structureModel==null||this.structureModel == {}){
                window.showAlert(this.$t("res_Msgs_FillRequired"), "warning");
            }
            else{
                window.showLoading()
                axios.get(constants.baseApiUrl + 'StructureUser/DeleteRecipientEntity?id='+Number(this.structure_id))
                            .then(response => {
                                if (response.data != null) {
                                    window.showAlert(this.$t("res_Msg_DeletedEntityRecipient"), "success");
                                    this.structureModel = null
                                    this.structure = null
                                    this.getRecipientEntity();
                                    
                                    this.$emit("removeIsEntityRecipient",[this.structure_id])
                                    window.hideLoading()
                                }
                            })
                            .catch(err => {console.warn(err);window.hideLoading()})
            }
        },
        addRecipientEntity(){
            if(this.structureModel == null || this.structureModel == {}){
                window.showAlert(this.$t("res_Msgs_FillRequired"), "warning");
            }
            else{
                window.showLoading()
                let payload={
                    EntityId: Number(this.structure_id),
                    RecipientId: Number(this.structureModel?.id ?? 0),
                    Id:0
                };
                axios.post(constants.baseApiUrl + 'StructureUser/AddEditRecipientEntity', payload)
                            .then(response => {
                                if (response.data != null) {
                                    window.showAlert(this.$t("res_Msg_AddedEntityRecipient"), "success");
                                    this.getRecipientEntity();
                                    this.$emit("addIsEntityRecipient",[this.structure_id])
                                    window.hideLoading()
                                }
                            })
                            .catch(err => {console.warn(err);window.hideLoading()})
            }
            
        },
        getRecipientEntity(){
            axios.get(constants.baseApiUrl + 'StructureUser/GetRecipientEntity?entityId='+this.structure_id)
                        .then(response => {
                            if (response.data != null && response.data.id>0) {
                                this.structure=response.data;
                                this.structureModel=response.data;
                            }
                        })
                        .catch(err => console.warn(err))
        
        },
    },
    
    filters: {
        limitText(text, maxSize){
            if (!text) return '';
            text = text.toString();

            if (text.length <= maxSize) {
                return text;
            }
            return text.substr(0, maxSize).trim() + ' ...';
        }
    },
    mounted: function () {
        this.getRecipientEntity();
    },
    watch: {
        structure_id(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.structureId = newVal
            }
        },
    }
}
</script>

<style>
    .customTextarea{ 
        width: 100%;
        border-radius: 8px; 
        background-color: #eff2f5;
        outline: none;
        padding: 10px 19px 10px 15px;
        height: 46px;
        line-height: 1.7; 
        overflow: hidden !important; 
    }
</style>

<style scoped>
    .container {
    width: "100%";
    padding: 8px 16px;
    }

    .buttons {
        display: flex;
        gap: 8px;
        justify-content: center;
        margin-top: 8px;
    }

    .vtooltip {
        background-color: white;
        padding: 5px;
        border-radius: 25px;
    }

    .report-container .v-input--selection-controls {
        margin-top: 0;
        padding-top: 0;
    }
    
    .report_header { 
        height: 50px;
        vertical-align: middle; 
        font-weight: 500;
        font-size: 12px;
        letter-spacing: 0.015em;
        color: #667593;
    }

    .report-container .theme--light.v-data-table.v-data-table--fixed-header thead th,  .report-container .v-data-table__wrapper table thead {
        background-color: #FFF;
        box-shadow: none;
    }

    .report-container {
        height: calc(100vh - 116px);
        display: flex;
        flex-direction: column;
        border-radius: 12px !important;
        overflow: auto;
        box-shadow: none !important;
    }

    .report-container .border-top {
        display: flex;
        flex-direction: column;
    }

    .report-container .v-toolbar {
        height: 80px !important;
        padding: 0;
    }
    .report-container .v-toolbar__content {
        height: 100% !important;
        padding: 24px !important;
    }
    
    img#ItemPreview {
        width: 100px;
        margin: 0.5rem 0;
    }

    .mdi-menu-down {
        filter: brightness(0) saturate(100%) invert(39%) sepia(56%) saturate(232%) hue-rotate(182deg) brightness(102%) contrast(83%) !important ;
    }
    
    .v-dialog .v-toolbar__content {
        height: 100% !IMPORTANT;
    }
</style> 